<template>
  <div class="g-db g-mt-10">
    <el-pagination
      :current-page="currentPage"
      :page-sizes="sizes"
      :page-size="defaultSize"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>
<script>
  export default {
    props: {
      currentPage: {
        type: Number,
        default: 1
      },
      total: {
        type: Number,
        default: 0
      },
      sizes: {
        type: Array,
        default: () => {
          return [20, 50, 100, 1000];
        }
      },
      defaultSize: {// 默认pagesize
        type: Number,
        default: 20
      }
    },
    methods: {
      handleSizeChange(val) {
        this.$emit('sizeChange', val);
      },
      handleCurrentChange(val) {
        this.$emit('currentChange', val);
      }
    },
  };

</script>



// WEBPACK FOOTER //
// src/components/page/index.vue